export const SYSTEM_DYNAMIC_OPTIONS = [
    { value: "{{user.id}}", label: "Current User ID", compatibleTypes: ["UUID", "TEXT", "REFERENCE"] },
    { value: "{{user.email}}", label: "Current User Email", compatibleTypes: ["TEXT"] },
];
